import {ChangeDetectionStrategy, Component, Input, OnChanges} from '@angular/core';

@Component({
    selector: 'app-school-year',
    templateUrl: './school-year.component.html',
    styleUrls: ['./school-year.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class SchoolYearComponent implements OnChanges {

  @Input()
  year: number;

  @Input()
  isMobile: boolean = false;

  formattedSchoolYear: string;

  constructor() {
  }

  ngOnChanges(): void {
    if (this.year) {
      if(typeof this.year === 'string') {
        this.year = parseFloat(this.year);
      }
      if (this.year < 2000 || this.year > 2200) {
        throw new Error('Invalid School Year :' + this.year);
      }
      if (this.isMobile) {
        this.formattedSchoolYear = this.year.toString().substring(2) + '/' + (this.year + 1).toString().substring(2);
      } else {
        this.formattedSchoolYear = this.year + '/' + (this.year + 1);
      }
    } else {
      this.formattedSchoolYear = '-'
    }
  }

}
